import Axios from 'axios';
import json from '../config/env.config.json';

export default class LogEventsService {
  constructor() {
    const configurationJson = json[process.env.REACT_APP_ENVIRONMENT];
    if (!configurationJson) {
      console.log('Configuration [Event logger] not found. Aborting. ');
    }
    this.path = configurationJson['REACT_APP_API_LOG'];
    this.apikey = configurationJson['REACT_APP_API_KEY'];
  };

  isLocalhost() {
    return (window.location.href.indexOf('localhost') !== -1) || (window.location.href.indexOf('127.0.0.1') !== -1);
  }

  loggedLogin(payload = null) {
    if (this.isLocalhost()) {
      console.log('[LOGIN] ', this.apikey, this.path, payload);
    }
    this._post(payload, 'LOGIN');
  }

  loggedLogout(payload = null) {
    if (this.isLocalhost()) {
      console.log('[LOGOUT] ', this.apikey, this.path, payload);
    }
    this._post(payload, 'LOGOUT');
  }

  loggedRetryLogin(payload = null) {
    if (this.isLocalhost()) {
      console.log('[LOGINTRY] ', this.apikey, this.path, payload);
    }
    this._post(payload, 'LOGINTRY');
  }

  async _post(payload, event, segment = '/loginEntries') {
    if (this.isLocalhost()) {
      console.log(`[LogEventService] 🛡️ Chiamata API evitata in localhost per: ${event}`);
      return Promise.resolve({ data: "Local environment, request skipped", status: 200 });
    }
    const path = `${this.path}${segment}`;
    
    const headers = {
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': this.apikey,
      }
    };
    const body = {
      "userName": payload,
      "operation": event,
      // "ipAddress": ip,
    };
    const json = JSON.stringify(body);
    return Axios.post(path, json, headers)
      .then(function (response) {
        return response;
      })
      .catch(error => console.error("LogEventService Error:", error));
  }
}
